<!-- STANDARD Modal Header (SuperPrompt V9) -->
<div class="modal-header">
  <h3 class="modal-title">{{title}}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- STANDARD Modal Body (SuperPrompt V9) -->
<div class="modal-body" [hidden]="minimise">
  <!-- Loader -->
  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  @if (!showFormLoader && formRows.length > 0) {
<div class="form-horizontal">
    <!-- Entity information table -->
    <table class="table table-bordered form-inline enityDetails">
      <tr>
        @for (item of entityList; track $index) {
<td>
          <span>{{ item.key }}</span>
        </td>
}
      </tr>
      <tr>
        @for (item of entityList; track $index) {
<td>
          <span>{{ item.value }}</span>
        </td>
}
      </tr>
    </table>

    <!-- DATE SECTION -->
    <div class="row form-group">
      <div class="col-md-6">
        <div class="row">
          <label class="col-md-6">{{formRows[0]?.description}}:</label>
          <div class="col-md-4">
            <input type="date" class="form-control"
                   [value]="formRows[0]?.value1"
                   (input)="onDateInput(0, $event)">
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="row">
          <label class="col-md-6">{{formRows[1]?.description}}:</label>
          <div class="col-md-4">
            <input type="date" class="form-control"
                   [value]="formRows[1]?.value1"
                   (input)="onDateInput(1, $event)">
          </div>
        </div>
      </div>
    </div>

    <!-- TABLE A-F -->
    <table class="table table-bordered form-inline">
      <tr>
        <td>{{formRows[2]?.num}}. {{formRows[2]?.description}}:
          <div>
            <input class="form-control input-md numText text_field_width"
                   type="text" maxlength="100" [(ngModel)]="formRows[2].value1">
          </div>
        </td>
        <td>{{formRows[5]?.num}}. {{formRows[5]?.description}}
          <div>
            <input class="form-control input-md numText text_field_width"
                   type="text" maxlength="10" [disabled]="true" [(ngModel)]="formRows[5].value1">
          </div>
        </td>
      </tr>
      <tr>
        <td>{{formRows[3]?.num}}. {{formRows[3]?.description}}
          <div>
            <input class="form-control input-md numText text_field_width"
                   type="text" [disabled]="true" [(ngModel)]="formRows[3].value1">
          </div>
        </td>
        <td>{{formRows[6]?.num}}. {{formRows[6]?.description}}
          <div>
            <input type="date" class="form-control"
                   [value]="formRows[6]?.value1"
                   (input)="onDateInput(6, $event)">
          </div>
        </td>
      </tr>
      <tr>
        <td>{{formRows[4]?.num}}. {{formRows[4]?.description}}
          <div>
            <select class="form-control" [(ngModel)]="formRows[4].value1"
                    (change)="updateColumnB(formRows[4].value1)">
              <option value="">Please Select</option>
              @for (code of codeMastMap; track $index) {
<option [value]="code.CODE_NAME">
                {{code.CODE_NAME}}
              </option>
}
            </select>
          </div>
        </td>
        <td>{{formRows[7]?.num}}. {{formRows[7]?.description}}
          <div class="input-group currency-input">
            <span class="input-group-addon">$</span>
            <input class="form-control input-md numText currency"
                   type="text" [disabled]="true" [ngModel]="formRows[7]?.value1 | number:'1.0-0'">
          </div>
        </td>
      </tr>
    </table>

    <!-- SECTION G - Check applicable boxes -->
    @if (formRows[8]) {
<div>
      {{formRows[8]?.num}}. {{formRows[8]?.description}}: &nbsp;&nbsp;&nbsp;
      @if (formRows[9]) {
<span>
        (1) <input type="checkbox" [checked]="formRows[9].value1 === 'Y'"
                   (change)="onCheckboxChange(9, $event)">
        <span class="diag_check">{{formRows[9]?.description}} &nbsp;&nbsp;</span>
      </span>
}
      @if (formRows[10]) {
<span>
        (2) <input type="checkbox" [checked]="formRows[10].value1 === 'Y'"
                   (change)="onCheckboxChange(10, $event)">
        <span class="diag_check">{{formRows[10]?.description}} &nbsp;&nbsp;</span>
      </span>
}
      @if (formRows[11]) {
<span>
        (3) <input type="checkbox" [checked]="formRows[11].value1 === 'Y'"
                   (change)="onCheckboxChange(11, $event)">
        <span class="diag_check">{{formRows[11]?.description}} &nbsp;&nbsp;</span>
      </span>
}
      @if (formRows[12]) {
<span>
        (4) <input type="checkbox" [checked]="formRows[12].value1 === 'Y'"
                   (change)="onCheckboxChange(12, $event)">
        <span class="diag_check">{{formRows[12]?.description}} &nbsp;&nbsp;</span>
      </span>
}
      @if (formRows[13]) {
<span>
        (5) <input type="checkbox" [checked]="formRows[13].value1 === 'Y'"
                   (change)="onCheckboxChange(13, $event)">
        <span class="diag_check">{{formRows[13]?.description}} &nbsp;&nbsp;</span>
      </span>
}
    </div>
}
    <p></p>

    <!-- SECTION H - Check accounting method -->
    @if (formRows[14]) {
<div>
      {{formRows[14]?.num}}. {{formRows[14]?.description}}: &nbsp;&nbsp;&nbsp;
      @if (formRows[15]) {
<span>
        (1) <input type="checkbox" [checked]="formRows[15].value1 === 'Y'"
                   (change)="onCheckboxChangeWithDisable(15, $event)">
        <span class="diag_check">{{formRows[15]?.description}} &nbsp;&nbsp;</span>
      </span>
}
      @if (formRows[16]) {
<span>
        (2) <input type="checkbox" [checked]="formRows[16].value1 === 'Y'"
                   (change)="onCheckboxChangeWithDisable(16, $event)">
        <span class="diag_check">{{formRows[16]?.description}} &nbsp;&nbsp;</span>
      </span>
}
      @if (formRows[17]) {
<span>
        (3) <input type="checkbox" [checked]="formRows[17].value1 === 'Y'"
                   (change)="onCheckboxChangeWithDisable(17, $event)">
        @if (formRows[18]) {
<span class="display_inline">{{formRows[18]?.description}}
          <input class="form-control input-md display_inline" style="width: 38%"
                 type="text" maxlength="100"
                 [disabled]="formRows[17].value1 !== 'Y'"
                 [(ngModel)]="formRows[18].value1">
        </span>
}
      </span>
}
    </div>
}
    <p></p>

    <!-- SECTION I - Number of Schedules K-1 -->
    @if (formRows[19]) {
<div>
      {{formRows[19]?.num}}.{{formRows[19]?.description}}
      <input class="form-control input-md numText display_inline" style="width: 38%"
             type="text" [(ngModel)]="formRows[19].value1">
    </div>
}
    <p></p>

    <!-- SECTION J - Check if Schedules C and M-3 are attached -->
    @if (formRows[20]) {
<div>
      {{formRows[20]?.num}}.{{formRows[20]?.description}}: &nbsp;&nbsp;&nbsp;
      <input type="checkbox" [checked]="formRows[20].value1 === 'Y'"
             (change)="onCheckboxChange(20, $event)">
    </div>
}
    <p></p>

    <!-- SECTION K - Check if partnership -->
    @if (formRows[21]) {
<div>
      {{formRows[21]?.num}}.{{formRows[21]?.description}}: &nbsp;&nbsp;&nbsp;
      @if (formRows[22]) {
<span>
        (1) <input type="checkbox" [checked]="formRows[22].value1 === 'Y'"
                   (change)="onCheckboxChange(22, $event)">
        <span class="diag_check">{{formRows[22]?.description}} &nbsp;&nbsp;</span>
      </span>
}
      @if (formRows[23]) {
<span>
        (2) <input type="checkbox" [checked]="formRows[23].value1 === 'Y'"
                   (change)="onCheckboxChange(23, $event)">
        <span class="diag_check">{{formRows[23]?.description}}</span>
      </span>
}
    </div>
}
    <p></p>

    <!-- TAX AND PAYMENT TABLE - FOR TAX YEAR <= 2022 -->
    @if (taxYear <= 2022) {
<div class="taxPaymentBlock">
      <table class="table table-bordered form-inline">
        <thead>
          <tr>
            <th colspan="2">
              <span>Tax and Payment</span>
            </th>
            <th colspan="1" class="subHeader">
              <span class="schd-ins">Total Amount</span>
            </th>
          </tr>
        </thead>
        <tbody>
          @for (row of formRows; track $index; let i = $index) {

            @if (row.num > 22 && row.num <= 30) {
<tr>
              <td style="width: 58px">{{row.num}}</td>
              <td>{{row.description}}</td>
              <td style="width: 110px" align="right">
                <div>
                  <input class="form-control input-md numText currency"
                         type="text"
                         [disabled]="row.num == 27 || row.num == 29 || row.num == 30"
                         [(ngModel)]="row.value1"
                         (ngModelChange)="computeValues2019()">
                </div>
              </td>
            </tr>
}
          
}
        </tbody>
      </table>

    <!-- Yes/No question for 2022 -->
    @if (formRows[57]) {
<div class="yes-no-row">
      {{formRows[57]?.description}}: &nbsp;&nbsp;&nbsp;
      <span class="yes-no-option">
        <span class="diag_check">Yes</span>
        <input type="checkbox" [checked]="formRows[57].value1 === true"
               (change)="formRows[57].value1 = true; fieldVisibility(57, formRows[57].value1, 'yes')">
      </span>
      <span class="yes-no-option">
        <span class="diag_check">No</span>
        <input type="checkbox" [checked]="formRows[57].value1 === false"
               (change)="formRows[57].value1 = false; fieldVisibility(57, formRows[57].value1, 'no')">
      </span>
    </div>
}
  </div>
}

    <!-- TAX AND PAYMENT TABLE - FOR TAX YEAR >= 2023 -->
    @if (taxYear >= 2023) {
<div class="taxPaymentBlock">
      <table class="table table-bordered form-inline">
        <thead>
          <tr>
            <th colspan="2">
              <span>Tax and Payment</span>
            </th>
            <th colspan="1" class="subHeader">
              <span class="schd-ins">Total Amount</span>
            </th>
          </tr>
        </thead>
        <tbody>
          @for (row of formRows; track $index; let i = $index) {

            @if (row.num > 23 && row.num <= 32) {
<tr>
              <td style="width: 58px">{{row.num}}</td>
              <td>{{row.description}}</td>
              <td style="width: 110px" align="right">
                <div>
                  <input class="form-control input-md numText currency"
                         type="text"
                         [disabled]="row.num == 28 || row.num == 31 || row.num == 32"
                         [(ngModel)]="row.value1"
                         (ngModelChange)="computeValues2023()">
                </div>
              </td>
            </tr>
}
          
}
          @if (routingNumberIndex >= 0) {
<tr>
            <td colspan="3" style="padding: 8px 8px 8px 66px;">
              <div style="margin-bottom: 4px;">
                <span>{{formRows[routingNumberIndex]?.num}}. {{formRows[routingNumberIndex]?.description}}</span>
                &nbsp;
                <input class="form-control input-md display_inline" type="text"
                       style="width: 140px;"
                       [(ngModel)]="formRows[routingNumberIndex].value1">
                &nbsp;&nbsp;&nbsp;
                @if (typeRowIndex >= 0) {
<span>
                  {{formRows[typeRowIndex]?.num}}. {{formRows[typeRowIndex]?.description}}:
                  &nbsp;
                  <input type="checkbox" [checked]="formRows[typeRowIndex].value1 === true"
                         (change)="formRows[typeRowIndex].value1 = true; fieldVisibility(typeRowIndex, true, 'yes')">
                  <span class="diag_check">Checking</span>
                  &nbsp;&nbsp;
                  <input type="checkbox" [checked]="formRows[typeRowIndex].value1 === false"
                         (change)="formRows[typeRowIndex].value1 = false; fieldVisibility(typeRowIndex, false, 'no')">
                  <span class="diag_check">Savings</span>
                </span>
}
              </div>
              @if (accountNumberIndex >= 0) {
<div>
                <span>{{formRows[accountNumberIndex]?.num}}. {{formRows[accountNumberIndex]?.description}}</span>
                &nbsp;
                <input class="form-control input-md display_inline" type="text"
                       style="width: 200px;"
                       [(ngModel)]="formRows[accountNumberIndex].value1">
              </div>
}
            </td>
          </tr>
}
        </tbody>
      </table>

       <!-- Yes/No: index 59 for 2023–2024, 62 for 2025+ (yesNoIndex set in processFormData) -->
       @if (yesNoIndex >= 0 && formRows[yesNoIndex]) {
<div class="yes-no-row">
        {{formRows[yesNoIndex]?.description}}: &nbsp;&nbsp;&nbsp;
        <span class="yes-no-option">
          <span class="diag_check">Yes</span>
          <input type="checkbox" [checked]="formRows[yesNoIndex].value1 === true"
                 (change)="formRows[yesNoIndex].value1 = true; fieldVisibility(yesNoIndex, formRows[yesNoIndex].value1, 'yes')">
        </span>
        <span class="yes-no-option">
          <span class="diag_check">No</span>
          <input type="checkbox" [checked]="formRows[yesNoIndex].value1 === false"
                 (change)="formRows[yesNoIndex].value1 = false; fieldVisibility(yesNoIndex, formRows[yesNoIndex].value1, 'no')">
        </span>
      </div>
}
    </div>
}

  </div>
}
</div>

<!-- STANDARD Modal Footer (SuperPrompt V9) -->
<div class="modal-footer" [hidden]="minimise">
  <button class="save-button"
          (click)="save()"
          [disabled]="isSaveClicked || crudLoading">
    @if (crudLoading) {
<i class="fa fa-spinner fa-spin"></i>
}
    Save and Proceed
  </button>
  <button class="reset-button" (click)="reset()">Reset</button>
  <button class="cancel-button" (click)="cancel()">Cancel</button>
</div>
